import React, {useCallback, useState} from 'react';
import styled, {useTheme} from 'styled-components/native';
import MainLayout from '../../mainLayout';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import Animated, {FadeInDown, FadeOutDown} from 'react-native-reanimated';
import {TouchableOpacity, View} from 'react-native';
import TextGeneric from '../../../components/textGeneric';
import {getUrlParts, isUrl, openUrl} from '../../../utils/helpers';
import {RouteProp, useRoute} from '@react-navigation/native';
import {
  CalculatorItemType,
  CalculatorRouteParams,
} from '../../../interfaces/api/content/home';
import {Space} from '../home';
import AccordionItem from '../../../components/accordionItem';
import {FlatList} from 'react-native-gesture-handler';
import useResponsiveDimensions from '../../../utils/hooks/useResponsiveDimensions';
import {tr} from '../../../translations';
import {isWeb} from '../../../utils/responsive';

const Container = styled.View`
  width: 100%;
  height: 100%;
`;
const CalculatorBodyText = styled(TextGeneric)`
  font-size: ${({theme}) => theme.text.s6 * 1.1}px;
  color: ${({theme}) => theme.text.dark};
`;
const CalculatorBodyTextUrl = styled(TextGeneric)`
  font-size: ${({theme}) => theme.text.s6 * 1.1}px;
  color: ${({theme}) => theme.text.dark};
  text-decoration-line: underline;
`;

const AnimatedList = styled(Animated.View)`
  width: 100%;
`;

const Calculators = () => {
  const theme = useTheme();
  const {bottom: bottomInset} = useSafeAreaInsets();
  const {getByScreenSize, hdp} = useResponsiveDimensions();

  const {data} = useRoute<RouteProp<CalculatorRouteParams>>().params || {
    data: [],
  };
  const [openItem, setOpenItem] = useState<number | null>(null);

  // Handle toggle for mutually exclusive accordions
  const handleToggle = useCallback(
    (index: number) => {
      setOpenItem(openItem === index ? null : index);
    },
    [openItem],
  );

  const _renderCustomBody = (item: CalculatorItemType) => {
    const parts = getUrlParts(item?.body || '');
    return (
      <View
        style={{
          width: '100%',
        }}>
        {parts.map((part, index) => {
          if (!part) {
            return null;
          }
          if (isUrl(part)) {
            return (
              <TouchableOpacity key={index} onPress={() => openUrl(part)}>
                <CalculatorBodyTextUrl bold>{part}</CalculatorBodyTextUrl>
              </TouchableOpacity>
            );
          }
          return <CalculatorBodyText key={index}>{part}</CalculatorBodyText>;
        })}
      </View>
    );
  };

  const _renderItem = ({
    item,
    index,
  }: {
    item: CalculatorItemType;
    index: number;
  }) => {
    return (
      <AccordionItem
        key={index}
        title={item?.title || ''}
        content={_renderCustomBody(item)}
        isOpen={openItem === index}
        onToggle={() => handleToggle(index)}
        style={{marginBottom: theme.text.s12}}
      />
    );
  };

  return (
    <MainLayout
      title={tr('screens.calculatorsPage')}
      backHeader
      noPadding
      noPaddingHeader
      enableScroll={isWeb}>
      <Container>
        <AnimatedList entering={FadeInDown.springify()} exiting={FadeOutDown}>
          <FlatList
            data={data || []}
            renderItem={_renderItem}
            contentContainerStyle={{
              paddingVertical: '5%',
              paddingHorizontal: '3%',
            }}
            //performance
            initialNumToRender={getByScreenSize(9, 20, 7)}
            ListFooterComponent={() => (
              <Space bottomInset={bottomInset} extraSpace={hdp(10)} />
            )}
          />
        </AnimatedList>
      </Container>
    </MainLayout>
  );
};
export default Calculators;
